export default __webpack_public_path__ + "static/media/comercio_20.1ee3109e.png";